import { jsonPost } from '@client/lib/request';

export const sendWebPushNotification = (data) => jsonPost('/mylounge-api/push-notification/send', data);
